export default [
    {
        path: '/commission',
        name: 'commission',
        meta: { layout: 'dashboard' },
        component: () => import('VIEWS/Catalogs/CommissionSettings.vue')
    }
]
